import { Product, ProductType } from "@/utils/types/product";
import { createSlice } from "@reduxjs/toolkit";

interface featuredProductsList {
  isLoading: boolean;
  isError: boolean;
  products:{
        productIDs:string[],
        productList:ProductType[]
  } ;
}

const initialState: featuredProductsList = {
  isLoading: false,
  isError: false,
  products: {
    productIDs:[],
    productList:[]
  },
};

export const featuredProductsSlice = createSlice({
  name: "featuredProductsSlice",
  initialState,
  reducers: {
    populateFeaturedProductIds: (state, action) => {
      if (action?.payload) {
        state.products.productIDs = action?.payload || [];
      }
    },
    populateFeaturedProductLists: (state, action) => {
        if (action?.payload) {
          state.products.productList = action?.payload || [];
        }
      },
  },
});

export const { populateFeaturedProductIds,populateFeaturedProductLists } = featuredProductsSlice.actions;
export const featuredProductsSliceReducer = featuredProductsSlice.reducer;
